import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslationsProvider } from '../../../core/translations.provider';

const assetsVideosPath = "assets/videos/";

@Component({
    selector: 'djiv-video-panel',
    templateUrl: './djiv-video-panel.component.html',
    styleUrls: ['./djiv-video-panel.component.css']
})
export class DjivVideoPanel implements OnInit{

    private translationsProvider : TranslationsProvider;
    protected videos: { title: string, videoPath: string, thumbnailPath: string }[] = [];

    protected language: string = "translations.default";
    protected videoFolder: string = "default";

    constructor(private http: HttpClient, private translateService: TranslateService, translationsProvider : TranslationsProvider ) {

        this.translationsProvider = translationsProvider;
        
        // Subscribe to the langauge change event
        this.translateService.onLangChange
            .subscribe(event => this.getLanguageVideosConfig());
    }

    ngOnInit(){
        this.http.get(`${assetsVideosPath}${this.language}.videos.json`).subscribe ( 
            (videos: {title: string, videoPath:string, thumbnailPath : string} [] ) => {
            this.videos = videos;
        });
    }

    getThumbnail(video: { title: string, videoPath: string, thumbnailPath: string }) {
        return `assets/videos/${this.language.slice(13)}/${video.thumbnailPath}`;
    }

    getVideo(video: { title: string, videoPath: string, thumbnailPath: string }) {
        return `assets/videos/${this.language.slice(13)}/${video.videoPath}`;
    }

    getLanguageVideosConfig() {

        this.language = this.translationsProvider.getLanguage();

        this.http.get(`${assetsVideosPath}${this.language}.videos.json`).subscribe ( 
            (videos: {title: string, videoPath:string, thumbnailPath : string} [] ) => {
            this.videos = videos;
        });

    }

}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-video-panel/djiv-video-panel.component.ts